import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/voice-settings`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },
  getTts(payload) {
    return Client.post(`${resource}/text-to-speech`, payload);
  },
};
